import axios from 'axios';
export default (corpId, creds) => {
  const promise = new Promise((resolve, reject) => {
    axios
      .patch(`${process.env.VUE_APP_API_ADMIN_LOCATION}organizations/${corpId}`, creds, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((error) => {
        reject(error);
      });
  });

  return promise;
};
